import APIConfiguration from '@savgroup-front-common/configuration/api';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
} from '@savgroup-front-common/types';

import { ConsoleEntityFieldFilter } from '@/api/Import/Console/getFilteredEntityDefintionBySellerCommand';
import { BulkActionType } from '@/api/Search/bulkActions.types';

const ENDPOINT = `${APIConfiguration.search}bulkActions/console`;

export interface CreateBulkActionJobFromConsoleCommandArgs {
  actionType: BulkActionType;
  actionParameters?: {
    importType: string;
    filters: ConsoleEntityFieldFilter[];
  };
  tenantId?: string;
  sellerId?: string;
}

export const createBulkActionJobFromConsoleCommand = async ({
  actionType,
  actionParameters,
  tenantId,
  sellerId,
}: CreateBulkActionJobFromConsoleCommandArgs): Promise<
  BackResponse<string> | BackResponseFailure
> => {
  try {
    return await apiCall<BackResponse<string>>(ENDPOINT, {
      method: SUPPORTED_METHODS.POST,
      json: {
        actionType,
        actionParameters,
        tenantId,
        sellerId,
      },
    });
  } catch (error) {
    return prepareResponseFailure(error);
  }
};
